<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Bin card'"></Breadcrumbs>
      <BinCard></BinCard>
    </div>
    <div class="col-md-12 home-tabs-body"></div>
  </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import BinCard from "@/components/inventories/binCard/BinCard.vue";

export default {
  name: "BinCardReport",
  components: { Breadcrumbs, BinCard },
};
</script>
